import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import bg from "../../../assets/img/Community.jpg";
import bgOrg from "../../../assets/img/Organization.jpg";
import bttnicon from "../../../assets/img/creat-post.svg";
import profile from "../../../assets/img/user 1.svg";
import banner from "../../../assets/img/profile/placeholder-img-event.svg";
const CommunityTopBar = (props) => {
   const communityData = JSON.parse(localStorage.getItem('communityData'));
   const user = JSON.parse(localStorage.getItem('userData'));
   const coverimage = communityData?.coverImage?.url
      ? process.env.REACT_APP_IMAGE_URL + communityData.coverImage.url : bg;
      const coverimageOrg = communityData?.coverImage?.url
      ? process.env.REACT_APP_IMAGE_URL + communityData.coverImage.url : bgOrg;

   const profileimage = communityData?.profileImage?.url
      ? process.env.REACT_APP_IMAGE_URL + communityData.profileImage.url : profile;

   return (
      <div>
         <div className="hd-breadcums">
            {props.type === "organization" ?
               <h3 className="main-heading"> {communityData?.firstName}</h3> :
               <h3 className="main-heading"> {communityData?.communityName}</h3>}

            
         </div>
         <div className="community-details">
            <div className='community_cover-img'>
                {props.type === "organization" ?
                 <img src={coverimageOrg} alt="test" className="cover-bg-community" /> :
               <img src={coverimage} alt="test" className="cover-bg-community" />}
               <div class="overlay"></div>
            </div>

            <div className="profile-div d-flex community-actions mb-5">
               <div class="community-icon-thumb">
                  <img src={profileimage} alt="test" className="community-detail-thumb" />
                  {props.type === "organization" ?
                     <h3 className="community-details-name"> {communityData?.firstName}</h3> :
                     <h3 className='community-details-name' >{communityData?.communityName}</h3>}
               </div>


            </div>
         </div>
      </div>

   );


};
export default CommunityTopBar;